import type { FC } from "react"

import styles from "./SalonRow.module.scss"

import FlagCheckbox from "../FlagCheckbox"
import type { FlagEditState } from "../useFeatureFlagTab"
import {
	type FragmentType,
	getFragmentData,
} from "@/souhl_admin/gql/__generated__"
import { graphql } from "@/souhl_admin/gql/__generated__/gql"

const SalonRowCompanyFeatureFlagFragment = graphql(/* GraphQL */ `
	fragment SalonRowCompanyFeatureFlag on CompanyFeatureFlag {
		featureFlag {
			id
		}
	}
`)

const SalonRowSalonFragment = graphql(/* GraphQL */ `
	fragment SalonRowSalon on Salon {
		id
		name
	}
`)

type Props = {
	salon: FragmentType<typeof SalonRowSalonFragment>
	isLast: boolean
	companyFeatureFlags: FragmentType<typeof SalonRowCompanyFeatureFlagFragment>[]
	flagStates: Record<string, FlagEditState>
	onSalonToggle: (flagId: string, salonId: number) => void
}

const getRowClassName = (isLast: boolean): string => {
	if (isLast) return styles.salonRowLast
	return styles.salonRow
}

const SalonRow: FC<Props> = ({
	salon,
	isLast,
	companyFeatureFlags,
	flagStates,
	onSalonToggle,
}) => {
	const salonData = getFragmentData(SalonRowSalonFragment, salon)
	const cfs = companyFeatureFlags.map((cf) =>
		getFragmentData(SalonRowCompanyFeatureFlagFragment, cf)
	)

	return (
		<tr className={getRowClassName(isLast)}>
			<td className={styles.labelTd}>
				<span className={styles.salonLabel}>
					【{salonData.id}】{salonData.name}
				</span>
			</td>
			{cfs.map((cf) => {
				const state = flagStates[cf.featureFlag.id]
				if (state?.companyWide) {
					return (
						<td key={cf.featureFlag.id} className={styles.flagTd}>
							<span className={styles.dash}>—</span>
						</td>
					)
				}
				const checked = state?.enabledSalonIds.includes(salonData.id) ?? false
				return (
					<td key={cf.featureFlag.id} className={styles.flagTd}>
						<FlagCheckbox
							checked={checked}
							onChange={() => onSalonToggle(cf.featureFlag.id, salonData.id)}
						/>
					</td>
				)
			})}
		</tr>
	)
}

export default SalonRow
